import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../api-response';
import { BaseApiService } from '../../../core/base-api.service';
import {
  CreateOperationProfileRequest,
  OperationProfile,
} from '../../operation-profile/models/operation-profile.model';

/**
 * Platform-default operation profiles (super-admin). Unlike tenant profiles
 * these have no per-operation endpoints: PUT replaces the whole default —
 * profile fields and the entire operations list — in a single call, so the
 * caller always sends the full operations array it wants to persist.
 */
@Injectable({
  providedIn: 'root',
})
export class AdminOperationDefaultService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${this.coreApiUrl}/api/v1/admin/operation-profile-default`;

  getDefaults(): Observable<ApiResponse<OperationProfile[]>> {
    return this.http.get<ApiResponse<OperationProfile[]>>(this.baseUrl);
  }

  getDefaultById(id: number): Observable<ApiResponse<OperationProfile>> {
    return this.http.get<ApiResponse<OperationProfile>>(`${this.baseUrl}/${id}`);
  }

  createDefault(request: CreateOperationProfileRequest): Observable<ApiResponse<OperationProfile>> {
    return this.http.post<ApiResponse<OperationProfile>>(this.baseUrl, request);
  }

  updateDefault(
    id: number,
    request: CreateOperationProfileRequest,
  ): Observable<ApiResponse<OperationProfile>> {
    return this.http.put<ApiResponse<OperationProfile>>(`${this.baseUrl}/${id}`, request);
  }

  deleteDefault(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
